"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusLight = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../styles/typography");
const styled_div_1 = require("./styled-div");
const StyledStatusLightText = styled_components_1.default(styled_div_1.StyledDiv) `
  color: ${(props) => props.theme.colors.textDefault};
  ${typography_1.defaultText}
  text-align: left;
`;
const StatusLight = ({ className, color, id, label, lightSize = '12px', style, }) => (react_1.default.createElement(StyledStatusLightText, { flex: true, flexDirection: "row", alignItems: "center", justifyContent: "flex-start", maxWidth: "200px", className: className, id: id, style: Object.assign({}, style) },
    react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", "data-testid": "status-light-svg", width: lightSize, height: lightSize, style: {
            marginRight: '8px',
            flexShrink: 0,
        } },
        react_1.default.createElement("circle", { cx: "50", cy: "50", r: "50", "data-testid": "status-light-circle", fill: color })),
    label));
exports.StatusLight = StatusLight;
exports.default = exports.StatusLight;
